<template lang="pug">
.v-dumb-banner.dumb-banner(v-if="banner" :class="{'dumb-banner--blackout': banner.blackout}")
	.dumb-banner__container.container
		.dumb-banner__wrap(v-if="banner.title || banner.subtitle || banner.action")
			.dumb-banner__background(:style="{'background': banner.backgroundImage}")
			.dumb-banner__background.dumb-banner__background--dark(:style="{'background': banner.backgroundImageDark}")
			.dumb-banner__left
				.dumb-banner__title(v-if="banner.title") {{banner.title}}
				.dumb-banner__subtitle.flc(v-if="banner.subtitle") {{banner.subtitle}}
				.dumb-banner__content.text-guide(v-if="banner.content" v-html="banner.content")
				.dumb-banner__action.flc
					template(v-for="(actionItem, actionItemIndex) in banner.action" :key="actionItemIndex")
						.dumb-banner__action-item.flc
							template(v-if="actionItem.modal")
								button(type="button" :class="actionItem.className" @click="openModal(actionItem)") {{actionItem.text}}
							template(v-else-if="actionItem.anchor")
								button(type="button" :class="actionItem.className" @click="scrollToAnchor(actionItem)") {{actionItem.text}}
							template(v-else)
								a(:class="actionItem.className" :href="actionItem.link") {{actionItem.text}}
			.dumb-banner__right(v-if="banner.image")
				img.dumb-banner__image(:src="banner.image" alt="" loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null
		};
	},

	methods: {
		openModal(actionItem) {
			if (actionItem.modal.component) {
				controller.openModal({
					className: actionItem.modal.className,
					component: actionItem.modal.component
				});
			} else if (actionItem.modal.content) {
				controller.openModal({
					className: actionItem.modal.className,
					content: `<v-modal-window>${actionItem.modal.content}</v-modal-window>`
				});
			}
		},

		scrollToAnchor(actionItem) {
			const $anchor = document.getElementById(actionItem.link);
			if ($anchor) {
				window.scrollTo({
					top: $anchor.offsetTop - 20,
					behavior: "smooth",
				});
			}
		},

		dataSet(data) {
			this.banner = data;
		}
	}
};
</script>